import { render, staticRenderFns } from "./blog2.vue?vue&type=template&id=3f19358e&scoped=true"
import script from "./blog2.vue?vue&type=script&lang=js"
export * from "./blog2.vue?vue&type=script&lang=js"
import style0 from "./blog2.vue?vue&type=style&index=0&id=3f19358e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f19358e",
  null
  
)

export default component.exports